import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/apiConfig";

export default function Footer() {
  const [s, setS] = useState({
    brand_name: "Eudemonie",
    footer_description: "Sophrologie caycédienne à Vanves.\nAccompagnement vers le bien-être et l'épanouissement.",
    phone: "+33 (0)7 67 91 73 70",
    email: "celine@eudemonie-sophro.fr",
    address: "Vanves, 92170 Hauts-de-Seine",
    instagram_url: "#",
    facebook_url: "#",
    nav_accompagnements_label: "Accompagnements",
    nav_sophrologie_label: "La Sophrologie",
    nav_blog_label: "Articles & Conseils",
    nav_tarifs_label: "Séances & Tarifs",
    nav_a_propos_label: "À Propos",
    nav_cta_label: "Prendre RDV",
  });

  useEffect(() => {
    axios.get(`${API}/public/settings`).then(r => { if (r.data) setS(prev => ({ ...prev, ...r.data })); }).catch(() => {});
  }, []);
  return (
    <footer className="bg-charcoal text-white/80 pt-16 pb-8">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-playfair text-white text-2xl mb-3">{s.brand_name || "Eudemonie"}</h3>
            <p className="font-manrope text-sm leading-relaxed text-white/60 mb-6 whitespace-pre-line">{s.footer_description}</p>
            <div className="flex gap-3">
              {s.instagram_url && <a href={s.instagram_url} data-testid="footer-instagram" className="p-2 rounded-full border border-white/20 hover:border-sage hover:text-sage transition-colors duration-200"><Instagram size={16} /></a>}
              {s.facebook_url && <a href={s.facebook_url} data-testid="footer-facebook" className="p-2 rounded-full border border-white/20 hover:border-sage hover:text-sage transition-colors duration-200"><Facebook size={16} /></a>}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-manrope font-medium text-white text-sm tracking-widest uppercase mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { href: "/accompagnements", label: s.nav_accompagnements_label },
                { href: "/sophrologie-caycedienne", label: s.nav_sophrologie_label },
                { href: "/blog", label: s.nav_blog_label },
                { href: "/seances-tarifs", label: s.nav_tarifs_label },
                { href: "/a-propos", label: s.nav_a_propos_label },
                { href: "/prendre-rendez-vous", label: s.nav_cta_label },
              ].map(l => (
                <li key={l.href}><Link to={l.href} className="text-sm hover:text-sage transition-colors duration-200">{String(l.label || "").replace(/\n/g, " ")}</Link></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-manrope font-medium text-white text-sm tracking-widest uppercase mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm"><MapPin size={15} className="text-sage shrink-0" /><span>{s.address}</span></li>
              <li className="flex items-center gap-3 text-sm"><Phone size={15} className="text-sage shrink-0" /><a href={`tel:${s.phone?.replace(/\s/g,'')}`} className="hover:text-sage transition-colors">{s.phone}</a></li>
              <li className="flex items-center gap-3 text-sm"><Mail size={15} className="text-sage shrink-0" /><a href={`mailto:${s.email}`} className="hover:text-sage transition-colors">{s.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-white/40">© 2024 Eudemonie. Tous droits réservés.</p>
          <div className="flex gap-4 text-xs text-white/40">
            <Link to="/admin" className="hover:text-white/60 transition-colors">Espace pro</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
